module.exports = {
  // 需要统计数据的路由列表
  routeList: [
    {
      name: '多品类科技馆',
      route: '/multiCategory/index', // 页面路由
      pageId: 'T7445', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '我的优惠券页',
      route: '/coupon/list/', // 页面路由
      pageId: 'H9643', // pageId从zeye上拷贝
      level: 5 // 页面级别
    },
    {
      name: '客服自助服务页',
      route: '/platform/independent-service', // 页面路由
      pageId: 'D9123', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '客服自助服务页',
      route: '/platform/independent-service', // 页面路由
      pageId: 'D9123', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '商城支付成功页',
      route: '/order/paySuccess', // 页面路由
      pageId: 'L5015', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '消息页',
      route: '/service/messageCenterList', // 页面路由
      pageId: 'E4488', // pageId从zeye上拷贝
      level: 5 // 页面级别
    },
    {
      name: '推送设置页',
      route: '/setting/recommend', // 页面路由
      pageId: 'H1240', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '资质协议页',
      route: '/protocol/qualification', // 页面路由
      pageId: 'W5503', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '消息页',
      route: '/service/messageCenter', // 页面路由
      pageId: 'D3700', // pageId从zeye上拷贝
      level: 10 // 页面级别
    },
    {
      name: '新媒中间页',
      route: '/activty/new-media-download', // 页面路由'
      pageId: 'T7484', // pageId从zeye上拷贝
      level: 10 // 页面级别
    }
  ]
}
